module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_square_blonde.6598011f.png";